'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ALIGNMENT_CLASSES = exports.ALIGNMENT_CLASSES = {
  'start': '',
  'baseline': 'private-checkbox--align-baseline',
  'center': 'private-checkbox--align-center',
  'end': 'private-checkbox--align-end'
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.348/js/input/CheckboxConstants.js
// module id = 245
// module chunks = 0 1